import { VendaCliente } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<VendaCliente>('vendas-clientes');
